import { Modal, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import './DownloadPopup.css';

const DownloadPopup = ({ showModal, setShowModal, dateFilter, setDateFilter, handleDownload, isDownloading  }) => {
    const { singleApplicationData } = useSelector((store) => {
        return {
            singleApplicationData: store.ApplicationReducer.singleApplication
        }
    }, []);

    const handleClose = () => {
        if (isDownloading) return;
        setShowModal(false);
    }

    return (
        <Modal
            show={showModal}
            onHide={handleClose}
            centered
            backdrop="static"
            contentClassName="download-modal-content"
            dialogClassName="download-modal"
            scrollable
            style={{ height: "auto"  }}
        >
            <Modal.Body
                className="w-100 download-modal-body"
            >
                <form className="download-modal-form">
                    <div className="date-input-group">
                        <label>E-sign Start Date</label><br />
                        <input 
                            type="date" 
                            name="startDate"
                            value={dateFilter.startDate}
                            onChange={(e) => {
                                setDateFilter((prev) => ({
                                    ...prev,
                                    startDate: e.target.value
                                }))
                            }}
                        />
                    </div>

                    <div className="date-input-group">
                        <label>E-Sign End Date</label><br />
                        <input 
                            type="date" 
                            name="endDate"
                            value={dateFilter.endDate}
                            onChange={(e) => {
                                setDateFilter((prev) => ({
                                    ...prev,
                                    endDate: e.target.value
                                }))
                            }}
                        />
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <Button 
                            variant="solid" 
                            style={{ backgroundColor: "#e7e7e7", color: "black" }}
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant="solid" 
                            style={{ backgroundColor: "#00409A", color: "white" }}
                            onClick={handleDownload}
                            disabled={isDownloading}
                       >
                            {isDownloading ? (
                                <>
                                    <span className="buttonSpinner"></span>
                                    Downloading...
                                </>
                            ) : (
                                'Download csv'
                            )}
                        </Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default DownloadPopup;